import * as Yup from 'yup';

export const accountValidation = Yup.object({
  name: Yup.string().required('Required'),
  businessId: Yup.string().required('Required'),
});

export type TAccount = Yup.InferType<typeof accountValidation>;
